module.exports = __webpack_public_path__ + "img/rojo.effe88c3.png";